module.exports = __webpack_public_path__ + "img/source.59255f81.png";